import { render, staticRenderFns } from "./DriverRoutes.vue?vue&type=template&id=3ab5379b&"
import script from "./DriverRoutes.vue?vue&type=script&lang=ts&"
export * from "./DriverRoutes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports